<template>
  <Modal
    v-model="state"
    title="分包累计监控提醒配置"
    width="600"
    class-name="c-config vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="m-form">
      <Form :label-width="80">
        <FormItem label="提醒规则">
          <Input
            class="row-item"
            v-model="landData.remindNum"
            placeholder="分包累计提醒数"
            style="display: inline-block; width: 180px; margin-bottom: 0"
            @on-blur="inputTrim('remindNum', landData.remindNum, landData)"
          />
          <span style="margin-left: 8px; vertical-align: top">分包数</span>
        </FormItem>
        <FormItem label="提醒方式">
          <RadioGroup v-model="landData.remindType" type="button">
            <Radio :label="1">仅钉钉</Radio>
            <!-- <Radio :label="2" disabled>仅邮件</Radio> -->
            <!-- <Radio :label="3" disabled>钉钉+邮件</Radio> -->
          </RadioGroup>
        </FormItem>
        <FormItem label="提醒人员">
          <Select v-model="opIds" multiple filterable transfer style="width: 260px" @on-change="handleOperator">
            <Option v-for="item in operatorData" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
    </div>

    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { isArray, isEmpty, trim } from '@/common/js/utils'
import { getSysMember } from '@/api/common.model'

export default {
  name: 'toutiaoGameConfigModal',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    info: {
      handler() {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    bindGetData(e) {
      if (e) return
      setTimeout(() => {
        this.landData = {
          remindNum: '',
          remindType: '',
          remindPeople: ''
        }
      }, 200)
    },
    updateInfo() {
      const info = JSON.parse(JSON.stringify(this.info))
      this.landData = info
      this.opIds = info.remindPeople.split(',').map((ret) => Number(ret))
    },
    // 提交验证
    save() {
      this.$emit('on-save', this.landData)
    },
    inputTrim(key, val, obj, fixed) {
      console.log(val)
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 100
        val = Math.floor(val) / 100
        val = Math.floor(val)
      } else val = parseInt(val)
      if (isNaN(val)) obj[key] = 0
      else obj[key] = val
    },
    handleOperator(meta) {
      this.landData.remindPeople = meta.join(',')
    },
    preLoadData() {
      Promise.all([getSysMember()]).then((data) => {
        const [operators] = data
        isArray(operators) && (this.operatorData = operators)
      })
    }
  },
  data() {
    return {
      landData: {
        remindNum: '',
        remindType: '',
        remindPeople: ''
      },
      opIds: '',
      operatorData: [] // 人员数据
    }
  },
  created() {
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-config {
  position: relative;

  .m-form {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    padding-top: 20px;
    max-height: 480px;
    max-width: 400px;
    min-width: 300px;
    margin: 0 auto;
  }

  .ivu-input-wrapper ::v-deep .ivu-input {
    font-size: 12px;
  }

  .result {
    width: 334px;
    margin: 0 auto;
  }
}

::v-deep .ivu-modal {
  min-width: 600px;
}
</style>
